var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.applyData)?_c('div',{staticClass:"report_layout clearfix",class:{
    'lnb-minimize': _vm.$store.state.layout.lnbMinimize,
    'gnb-minimize': _vm.$store.state.layout.gnbMinimize
  }},[_c('report-menu'),_c('report-header'),(_vm.showReportPageList)?_c('page-list',{on:{"onPageClick":_vm.onPageClick}}):_vm._e(),_c('router-view',{staticClass:"content"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }